export default __webpack_public_path__ + "static/media/gallery-wip-handle_06.a1e5f04c.jpg";